// For environment details see: https://confluence.mtvi.com/display/TCP/Global+Entry+-+execution+environment+-+Level+1+-+development
export const version = '2023-12-20_undefined';
export const aspera_uid = 'undefined';
export const aspera_pwd = 'undefined';
//# sourceMappingURL=environment.common.js.map